// import logo from './logo.svg';
import "./Contact.css";

function Contact() {
  return (
    <>
      <div className="Contact">
        <div id="hw-hero">
          <div id="page-header" class="about1">
            <div class="title-breadcrumbs">
              <h1>CONTACT</h1>
              <div class="thebreadcumb">
                <ul class="breadcrumb">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  {/* <li>Pages</li>
                  <li>About</li> */}
                  <li class="active">CONTACT</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <section class="introtext about1 greyback">
          <div class="row">
            <div class="col-sm-12">
              <h2>
                WE’D LOVE TO HEAR FROM YOU
                {/* DISCOVER THE <span>FINANCIAL KEYS</span> TO GROW SUCCESSFULLY */}
              </h2>
              <p class="text-center">
                V T THOMAS & ASSOCIATES IS A LEADING TAX CONSULTANCY AND
                MANAGEMENT CONSULTANCY FIRM BASED OUT IN KATTAPPANA IDUKKI
                KERALA. V T THOMAS AND ASSOCIATES HAVE its ORIGIN since 1982
              </p>
              <hr class="small" />
            </div>
          </div>

          <div class="about1-numbers">
            <div class="row">
              <div
                class="col-sm-4 wow fadeInUp"
                data-wow-duration="1000ms"
                data-wow-delay="300ms"
              >
                <div class="shadow-effect">
                  <div class="row">
                    <div class="col-sm-12 col-md-3">
                      <div class="number lightgray">1</div>
                    </div>
                    <div class="col-sm-12 col-md-9">
                      <h4>CALL US</h4>

                      <p>
                        04868 272484, 9446339908 <br></br> <br></br>
                        9447313414, 9400969764
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="col-sm-4 wow fadeInUp"
                data-wow-duration="1000ms"
                data-wow-delay="500ms"
              >
                <div class="shadow-effect">
                  <div class="row">
                    <div class="col-sm-12 col-md-3">
                      <div class="number blue">2</div>
                    </div>
                    <div class="col-sm-12 col-md-9">
                      <h4>MAIL US</h4>
                      <p>
                        vtthomas414@gmail.com <br></br>
                        <br></br>&nbsp;
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="col-sm-4 wow fadeInUp"
                data-wow-duration="1000ms"
                data-wow-delay="700ms"
              >
                <div class="shadow-effect">
                  <div class="row">
                    <div class="col-sm-12 col-md-3">
                      <div class="number green">3</div>
                    </div>
                    <div class="col-sm-12 col-md-9">
                      <h4>ADDRESS</h4>
                      <p>
                        Jolly Medicals Building<br></br>
                        Gandhi Square Road,<br></br>
                        Kattappana - 685508
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="about2-team">
          <div class="row">
            <div class="col-sm-12">
              <h2>
                MEET <span>OUR TEAM</span>
              </h2>
              <p class="text-center">
              These is the team behind V.T.Thomas & Associates
              </p>

              <div class="block-grid-md-3 block-grid-sm-2 block-grid-xs-1 team2-grid">
                <div
                  class="block-grid-item black wow fadeInUp"
                  data-wow-duration="500ms"
                  data-wow-delay="100ms"
                >
                  <div class="shadow-effect">
                    <img src="images/vt1.jpg" alt="" />
                    <div class="team-details">
                      <h3>VT THOMAS</h3>
                      <h6>Managing Director</h6>
                      {/* <p>
                        Rapaciously seize adaptive infomediaries and
                        user-centric intellectual capital. Collaboratively
                        unleash market-driven.
                      </p> */}
                      <ul class="team-social-links">
                        {/* <li>
                          <a href="#" title="Twitter">
                            <i class="fa fa-twitter"></i>
                          </a>
                        </li> */}
                        <li>
                          <a href="https://www.linkedin.com/in/jacob-tom-3b0214272/" title="Facebook"  target="_blank">
                            <i class="fa fa-facebook"></i>
                          </a>
                        </li>
                        <li>
                          <a href="https://www.linkedin.com/in/jacob-tom-3b0214272/" title="Linkedin"  target="_blank">
                            <i class="fa fa-linkedin"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  class="block-grid-item black wow fadeInUp"
                  data-wow-duration="500ms"
                  data-wow-delay="200ms"
                >
                  <div class="shadow-effect">
                    <img src="images/tom4.jpg" alt="" />
                    <div class="team-details">
                      <h3>TOM THOMAS</h3>
                      <h6>Managing Consultant</h6>
                      {/* <p>
                        Rapaciously seize adaptive infomediaries and
                        user-centric intellectual capital. Collaboratively
                        unleash market-driven.
                      </p> */}
                      <ul class="team-social-links">
                        {/* <li>
                          <a href="#" title="Twitter">
                            <i class="fa fa-twitter"></i>
                          </a>
                        </li> */}
                        <li>
                          <a href="https://www.facebook.com/TOMVALU" title="Facebook" target="_blank" >
                            <i class="fa fa-facebook"></i>
                          </a>
                        </li>
                        <li>
                        <a href="https://www.linkedin.com/in/jacob-tom-3b0214272/" title="Linkedin"  target="_blank">
                            <i class="fa fa-linkedin"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  class="block-grid-item black wow fadeInUp"
                  data-wow-duration="500ms"
                  data-wow-delay="300ms"
                >
                  <div class="shadow-effect">
                    <img src="images/jacob1.jpg" alt="" />
                    <div class="team-details">
                      <h3>JACOB TOM</h3>
                      <h6>Tax Consultant</h6>
                      {/* <p>
                        Rapaciously seize adaptive infomediaries and
                        user-centric intellectual capital. Collaboratively
                        unleash market-driven.
                      </p> */}
                      <ul class="team-social-links">
                        {/* <li>
                          <a href="#" title="Twitter">
                            <i class="fa fa-twitter"></i>
                          </a>
                        </li> */}
                        <li>
                          <a href="https://www.facebook.com/jacob.t.valummel" title="Facebook"  target="_blank">
                            <i class="fa fa-facebook"></i>
                          </a>
                        </li>
                        <li>
                        <a href="https://www.linkedin.com/in/jacob-tom-3b0214272/" title="Linkedin"  target="_blank">
                            <i class="fa fa-linkedin"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="about2-team">
          <div class="row">
            <div class="col-sm-12">
              <h2>
                OUR <span>LOCATION</span>
              </h2>
            

              <div id="map_wrapper">
                <div id="map_canvas" class="mapping">
                  {/* <iframe id="ifr"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15768.468197460747!2d76.6678971!3d8.8686944!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xbea49c0ba6cab3f3!2sMannam+Memorial+NSS+College!5e0!3m2!1sen!2sin!4v1490909624332"
              width="100%"
              height="220"
              frameborder="0"
              
              allowfullscreen
            ></iframe> */}

                  <div className="row">
                    <div className="col-md-12">
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3932.138307169074!2d77.11287667459229!3d9.754350277214327!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b07a9fd7c985fc7%3A0x4722561f86db3400!2sV.T%20THOMAS%20AND%20ASSOCIATES!5e0!3m2!1sen!2sin!4v1702239413488!5m2!1sen!2sin"
                        width="100%"
                        height="450"
                        allowfullscreen=""
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div class="spacing-65"></div>
      </div>
    </>
  );
}

export default Contact;
